module.exports = __webpack_public_path__ + "static/img/equ2.c2bf1e40.png";